export enum QuoraEventName {
  Purchase = 'Purchase',
  GeneratedLead = 'GenerateLead',
}

export interface QuoraUser {
  email?: string | null;
  phone_number?: string | null;
  name?: string;
  ip?: string;
  country?: string;
  region?: string;
  city?: string;
  postal_code?: string;
  job_title?: string;
  date_of_birth?: string;
}

export interface QuoraDevice {
  mobile_device_id?: string;
  referrer?: string;
  user_agent?: string;
  language?: string;
}

export interface QuoraConversionEvent {
  clickId: string
  eventName: QuoraEventName
  value: number
  user?: QuoraUser;
  device?: QuoraDevice;
}
